module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEzIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjUxNjQ1NSAyLjk3ODc3TDUuMDI4MTYgNy40OTA0N0M1LjcwNzUzIDguMTY5ODQgNi44MDQ5NyA4LjE2OTg0IDcuNDg0MzQgNy40OTA0N0wxMS45OTYgMi45Nzg3N0MxMy4wOTM1IDEuODgxMzMgMTIuMzA5NiAwIDEwLjc1OTIgMEgxLjczNTgzQzAuMTg1NDggMCAtMC41ODA5ODcgMS44ODEzMyAwLjUxNjQ1NSAyLjk3ODc3WiIgZmlsbD0iI0RDRENEQyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/Down-grey.svg
// module id = gLG7
// module chunks = 0